<template>
  <Layout tituloPagina="Sistema | Ajustes | Menú de usuario">
    <div class="row mb-4">
      <div class="col-md-2 col-2 mb-3"></div>
      <div class="col-md-8 col-8 mb-3">
        <filtrador
          v-on:dato-actualizado="
            dato = $event,
            refrescarOpciones()
          "
          :datoini="dato"
          placeholder="Dato del opciones de menú"
        ></filtrador>
      </div>
      <div class="col-md-2 col-2 mb-3">
        <button class="btn btn-success bx-pull-right" @click="nuevaOpcion()">
          <span class="d-none d-sm-block">
            <i class="mdi mdi-plus-thick"></i>
            Nuevo opción
          </span>
          <span class="d-block d-sm-none">
            <i class="mdi mdi-plus-thick"></i>
          </span>
        </button>
      </div>
    </div>

    <div class="card">
      <div class="card-header justify-content-between d-flex align-items-center">
        <h4 class="card-title">Opciones de menú individuales</h4>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-hover align-middle table-nowrap" id="tabla-opciones-menu">
            <thead>
              <tr>
                <th style="width: 50px">Icono</th>
                <th>Descripción</th>
                <th>URL</th>
                <th style="width: 100px">Tipo</th>
                <th class="text-center" style="width: 180px">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="opcion in opciones_menu" :key="opcion.id">
                <td class="text-center">
                  <i
                    class="mdi"
                    style="font-size: 20px;"
                    :class="opcion.icono"
                  ></i>
                </td>
                <td>{{ opcion.descripcion }}</td>
                <td>
                  <a 
                    :href="opcion.url"
                    :target="opcion.nueva_ventana ? '_blank' : '_self'"
                    :rel="opcion.nueva_ventana ? 'noopener noreferrer' : null"
                  >
                    {{ opcion.url }}

                    <span v-if="opcion.nueva_ventana" class="ms-1 text-muted" title="(Se abre en ventana nueva)">
                      <i class="mdi mdi-open-in-new"></i>
                    </span>
                  </a>
                </td>
                <td>{{ opcion.usuario ? 'Individual' : 'Global' }}</td>
                <td class="text-center">
                  <button
                    class="btn btn-warning btn-sm me-1"
                    @click="edicionOpcion(opcion)"
                  >
                    <i class="mdi mdi-content-save-edit-outline"></i>
                    Edición
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    @click="preguntaEliminar(opcion)"
                  >
                    <i class="mdi mdi-trash-can-outline"></i>
                    Eliminar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="text-center">
      <paginador
        :pag="page"
        :totpag="totpag"
        :epp="epp"
        @cargar-pagina="cargarPagina"
        @epp-actualizado="
          epp = $event,
          refrescarOpciones()
        "
      ></paginador>
    </div>

    <mdl-opciones
      ref="mdlOpciones"
      @refrescar-opciones="refrescarOpciones()"
    />

    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main"

import Paginador from '@/components/Paginador.vue'
import Filtrador from '@/components/Filtrador.vue'
import OpcionMenuPersonalizadoSrv from "@/services/OpcionMenuPersonalizadoSrv.js"
import MdlOpciones from './MdlOpciones.vue'

import Swal from 'sweetalert2'

export default {
  name: 'MenuUsuario',
  components: { 
    Layout,
    Paginador,
    Filtrador,
    MdlOpciones
  },
  data() {
    return {
      dato: '',
      page: 1,
      epp: parseInt(localStorage.getItem('argusblack.sistema.menu_usuario.epp') || 10),
      to: 0, // Total de opciones de menu
      totpag: 0, // Total de páginas
      opciones_menu: []
    }
  },
  created: function() {
    var self = this
    if (self.$route.query.dato) self.dato = self.$route.query.dato
    if (self.$route.query.page) self.page = parseInt(self.$route.query.page)
    if (self.$route.query.epp) self.epp = parseInt(self.$route.query.epp)

    self.refrescarOpciones()
  },
  methods: {
    cargarPagina: function(n) {
      var self = this
      self.page = n
      self.refrescarOpciones({ page: n })
    },

    preguntaEliminar: function(opcion) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swal.fire({
        title: "¿Eliminar la opción de menu?",
        html: "¿Está seguro de eliminar la opción de menu <br><b>"+opcion.descripcion+"</b>?",
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          OpcionMenuPersonalizadoSrv.eliminar(opcion.id).then(response => {
            swal.fire("Eliminado!", "Opción de menu "+opcion.descripcion+" eliminado.", "success");
            self.refrescarOpciones()
          }).catch(error => {
            let mensaje
            try {
              mensaje = error.response.data.message
            } catch (e) {
              mensaje = "No se pudo eliminar la opcion de menu "+opcion.descripcion
            }
            iu.msg.error(mensaje)
            console.log(error)
          })
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },

    nuevaOpcion: function(modo = 'nueva') {
      var self = this
      self.$refs.mdlOpciones.mostrar(modo)
    },

    edicionOpcion: function(opcion, modo = 'edicion') {
      var self = this
      self.$refs.mdlOpciones.mostrar(modo, opcion.id)
    },
    
    refrescarOpciones: function() {
      var self = this

      iu.spinner.mostrar('#tabla-opciones-menu')

      self.$router.replace({
        query: {
          dato: self.dato,
          page: self.page,
          epp: self.epp
        }
      }).catch(error => {})

      let params = {
        dato: self.dato,
        page: self.page,
        epp: self.epp,
        sin_paginacion: false,
        con_menu: true,
        con_usuario: true,
        orden: 'desc'
      }

      OpcionMenuPersonalizadoSrv.opcionesJSON(params).then(response => {
        localStorage.setItem('argusblack.sistema.menu_usuario.epp', self.epp)
        let page = response.data
        self.opciones_menu = page.data
        self.to = page.total
        self.totpag = page.last_page

        if (self.totpag < self.page) {
          self.page = self.totpag
          self.refrescarOpciones()
        }
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudieron cargar las opciones de menu'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally (() => {
        iu.spinner.ocultar('#tabla-opciones-menu')
      })
    }
  },
  mounted() {
    iu.spinner.mostrar('#tabla-opciones-menu')
  }
}
</script>

<style>
</style>